<template>
  <div class="specialproducts">
    <div class="topcontent" v-if="data.length > 0">
      <cube-scroll
        ref="scroll"
        :direction="direction"
        class="horizontal-scroll-list-wrap"
      >
        <div class="itemcontent" ref="items">
          <div
            class="itembox"
            @click="itemClick(index)"
            :class="{ 'itembox-active': curindex === index }"
            v-for="(item, index) in data"
            :key="index"
          >
            <img :src="imgBaseUrl + item.typeimg" />
            <p>{{ item.name }}</p>
          </div>
        </div>
      </cube-scroll>
    </div>
    <div class="content" v-if="data.length > 0">
      <swiper
        ref="mywiper"
        class="swiper"
        :not-next-tick="true"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="(item, index) in data[curindex].productimg"
          :key="index"
        >
          <div
            class="img"
            :style="{ backgroundImage: 'url(' + imgBaseUrl + item + ')' }"
          ></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination">
          <div class="pagination">
            {{ slideindex }}/{{ data[curindex].productimg.length }}
          </div>
        </div>
      </swiper>
      <p class="title">【{{ data[curindex].name }}】</p>
      <p class="synopsis">
        {{ data[curindex].synopsis }}
      </p>
    </div>
    <nodata :nodata="nodata" :msg="'暂无数据~'"></nodata>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import imgBaseUrl from "@/util/imgconfig";
import { getSpecialProducts } from "@/api/api";
var _this;
const DIRECTION_H = "horizontal";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    // swiper() {
    //   console.log(this.$refs);
    //   return this.$refs.mywiper.$swiper;
    // }
  },
  data() {
    return {
      dictValue: "",
      nodata: false,
      data: [],
      direction: DIRECTION_H,
      curdata: {},
      slideindex: 1,
      curindex: 0,
      imgBaseUrl: imgBaseUrl.imgBaseUrl,
      swiperOption: {
        notNextTick: true,
        slidesPerView: "auto",
        loopedSlides: 5,
        spaceBetween: 5,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        onTransitionStart(swiper) {
          console.log(swiper);
          _this.slideindex = swiper.snapIndex + 1;
        },
        on: {
          transitionEnd: function () {
            _this.slideindex = this.snapIndex + 1;
          },
        },
      },
    };
  },
  methods: {
    itemClick(index) {
      console.log(this.$refs.mywiper);
      this.$refs.mywiper.swiper.slideTo(0, 0, false);
      _this.slideindex = 1;
      _this.curindex = index;
    },
    changePage(current) {
      this.slideindex = current.previousIndex;
      console.log(current);
    },
    getSpecialProducts() {
      getSpecialProducts(_this.dictValue).then((res) => {
        console.log(res);
        // _this.nodata = true;
        if (res.code == 200 && res.data.length > 0) {
          _this.data = res.data;
          _this.curindex = 0;
        } else {
          _this.data = [];
          _this.nodata = true;
        }
      });
    },
    _adjust() {
      // waiting ui
      this.$nextTick(() => {
        const isHorizontal = this.direction === DIRECTION_H;
        const targetProp = isHorizontal ? "clientWidth" : "clientHeight";
        const active = this.curindex;
        const viewportSize = this.$refs.scroll.$el[targetProp];
        const itemsEle = this.$refs.items;
        const scrollerSize = itemsEle[targetProp];
        const minTranslate = Math.min(0, viewportSize - scrollerSize);
        const middleTranslate = viewportSize / 2;
        const items = itemsEle.children;
        let size = 0;
        this.data.every((label, index) => {
          if (index === active) {
            size += items[index][targetProp] / 2;
            return false;
          }
          size += items[index][targetProp];
          return true;
        });
        let translate = middleTranslate - size;
        translate = Math.max(minTranslate, Math.min(0, translate));
        this.$refs.scroll.scrollTo(
          isHorizontal ? translate : 0,
          isHorizontal ? 0 : translate,
          300
        );
      });
    },
  },
  watch: {
    curindex(newVal) {
      console.log(newVal);
      // this.$emit(EVENT_CHANGE, newVal)
      this._adjust();
    },
  },
  directives: {
    // swiper: directive
  },
  mounted() {},
  created() {
    _this = this;
  },
  activated() {
    if (this.$eshimin) {
      this.$eshimin.setTitle({
        title: "特色农产品",
        onResponse: function (res) {
          console.log("setTitle res:" + res);
        },
      });
    }
    if (this.dictValue != this.$route.query.areacode) {
      this.dictValue = this.$route.query.areacode || "450204";
      this.getSpecialProducts();
    }
  },
};
</script>

<style lang="less">
.specialproducts {
  min-height: 100%;
  background-color: #ffffff;
  .topcontent {
    background-color: #f4f6f8;
    padding: 15px 15px 20px 15px;
    .horizontal-scroll-list-wrap {
      .cube-scroll-content {
        display: inline-block;
      }
      .itemcontent {
        white-space: nowrap;
        display: flex;
        .itembox {
          display: inline-block;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 4px;
          width: 76px;
          height: 93px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 44px;
            height: 44px;
            border-radius: 4px;
          }
          p {
            text-align: center;
            padding-top: 4px;
            font-size: 12px;
            font-weight: 400;
            color: #000000;
            line-height: 17px;
          }
        }
        .itembox-active {
          background: #ffffff;
          box-shadow: 0px 2px 15px 0px rgba(8, 130, 243, 0.1);
        }
        .itembox + .itembox {
          margin-left: 5px;
        }
      }
    }
  }
  .content {
    padding: 15px 15px 20px 15px;
    .swiper-slide {
      width: 312px;
      height: 160px;
      border-radius: 4px;
      .img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background-image: url("../icons/png/aaa.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      }
    }
    .swiper-pagination {
      left: 0;
      bottom: 0;
      .pagination {
        background: rgba(0, 0, 0, 0.48);
        border-radius: 0px 4px 0px 4px;
        padding: 0 15px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
      }
    }
    .title {
      padding-top: 20px;
      font-size: 16px;
      font-weight: 550;
      color: #333333;
      line-height: 22px;
    }
    .synopsis {
      padding-top: 10px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      white-space: pre-line;
    }
  }
}
</style>
